import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ChatBubbleOutline = function ChatBubbleOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10547 22.5742C6.46289 22.5742 9.20703 21.2559 11.2773 19.7812C18.1719 19.9082 23.3281 15.9238 23.3281 10.6895C23.3281 5.64062 18.2793 1.57812 11.9902 1.57812C5.70117 1.57812 0.662109 5.64062 0.662109 10.6895C0.662109 13.9023 2.6543 16.7637 5.71094 18.2578C5.29102 19.0488 4.54883 20.1328 4.12891 20.6992C3.50391 21.5293 3.93359 22.5742 5.10547 22.5742ZM6.28711 20.5527C6.16016 20.6016 6.11133 20.5332 6.19922 20.4258C6.69727 19.8203 7.42969 18.8535 7.79102 18.1699C8.08398 17.6328 7.98633 17.1641 7.36133 16.8711C4.38281 15.4746 2.6543 13.2383 2.6543 10.6895C2.6543 6.76367 6.79492 3.57031 11.9902 3.57031C17.1855 3.57031 21.3262 6.76367 21.3262 10.6895C21.3262 14.6152 17.1855 17.8184 11.9902 17.8184C11.8145 17.8184 11.541 17.8086 11.209 17.8086C10.7891 17.7988 10.4766 17.9258 10.0859 18.2285C8.9043 19.1074 7.15625 20.2012 6.28711 20.5527Z"
  })));
};

ChatBubbleOutline.displayName = 'ChatBubbleOutline';
export default ChatBubbleOutline;